// TODO: is this specific to a page? move to template or lib file and include in script-tags.liquid
function toggleMenuMb() {
  let accordionMbMenu3 = document.querySelectorAll(
    ".level-2 .mobile-nav__item--2.has-child .mobile-nav__link"
  );

  accordionMbMenu3.forEach((item) => {
    item.addEventListener("click", function (e) {
      e.target.parentElement.classList.remove("is-active");
      e.target.parentElement.classList.toggle("is-open");
    });
  });
}


// TODO: can this be moved to lib.read-more.js?
const SeeMore = (() => {
  let s;

  return {
    settings() {
      return {
        content: document.querySelectorAll(".js-see-more"),
        originalContentArr: [],
        truncatedContentArr: [],
        moreLink: "See More",
        lessLink: "See Less",
      };
    },

    init() {
      s = this.settings();
      this.bindEvents();
    },

    bindEvents() {
      SeeMore.truncateText();
    },

    countWords(str) {
      return str.split(/\s+/).length;
    },

    ellipseContent(str, wordsNum) {
      return str.split(/\s+/).slice(0, wordsNum).join(" ") + "...";
    },

    truncateText() {
      for (let i = 0; i < s.content.length; i++) {
        s.content[i].querySelectorAll("span, p, strong").forEach(el => {
          el.textContent.trim() === "" && el.parentNode.removeChild(el)
        })
        const originalContent = s.content[i].innerHTML;
        const numberOfWords = s.content[i].dataset.rmWords / 2;
        const truncateContent = SeeMore.ellipseContent(
          originalContent,
          numberOfWords
        );

        const originalContentWords = SeeMore.countWords(originalContent);
        s.originalContentArr.push(originalContent);
        s.truncatedContentArr.push(truncateContent);

        if (numberOfWords < originalContentWords) {
          s.content[i].innerHTML = s.truncatedContentArr[i];
          let self = i;
          SeeMore.createLink(self);
        }
      }
      SeeMore.handleClick(s.content);
    },

    createLink(index) {
      const linkWrap = document.createElement("span");

      linkWrap.className = "read-more__link-wrap";

      linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;
      // Inset created link
      s.content[index].parentNode.insertBefore(
        linkWrap,
        s.content[index].nextSibling
      );
    },

    handleClick(el) {
      const readMoreLink = document.querySelectorAll(".read-more__link");

      for (let j = 0, l = readMoreLink.length; j < l; j++) {
        readMoreLink[j].addEventListener("click", function () {
          const moreLinkID = this.getAttribute("id");
          let index = moreLinkID.split("_")[1];

          el[index].classList.toggle("is-enlarged");

          if (this.dataset.clicked !== "true") {
            el[index].innerHTML = s.originalContentArr[index];
            this.innerHTML = s.lessLink;
            this.dataset.clicked = true;
          } else {
            el[index].innerHTML = s.truncatedContentArr[index];
            this.innerHTML = s.moreLink;
            this.dataset.clicked = false;
          }
        });
      }
    },

    openAll() {
      const instances = document.querySelectorAll(".read-more__link");
      for (let i = 0; i < instances.length; i++) {
        content[i].innerHTML = s.truncatedContentArr[i];
        instances[i].innerHTML = s.moreLink;
      }
    },
  };
})();
SeeMore.init();

// TODO: can this be moved to lib.shopify-theme-sections.js?

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
toggleMenuMb();

$(document).ready(function () {
  // Product page
  $(".content__tab").click(function (e) {
    $(".content__tab-active").removeClass("content__tab-active");
    $(this).addClass("content__tab-active");
    $(".accordion__panel--active").removeClass("accordion__panel--active");
    $("#" + $(this).attr("data-tab")).addClass("accordion__panel--active");
  });

  $(".inner_content__tab").click(function (e) {
    if($(this).hasClass("inner_content__tab-active")) {
      $(this).removeClass("inner_content__tab-active").attr('aria-expanded', 'false').text('See More');
      $("#" + $(this).attr("data-tab")).removeClass("inner_accordion__panel--active").attr('aria-hidden', 'true');
    } else {
      $(this).addClass("inner_content__tab-active").attr('aria-expanded', 'true').text('See Less');
      $("#" + $(this).attr("data-tab")).addClass("inner_accordion__panel--active").attr('aria-hidden', 'false');
    }
  });

  if ($(".editorial-slider").length > 0) {
    let slider = tns({
      container: ".editorial-slider",
      items: 1,
      slideBy: "page",
      swipeAngle: false,
      navPosition: "bottom",
      nav: true,
      responsive: {
        768: {
          items: 1,
          nav: false,
        },
      },
    });
  }
  
  $(document).on('keydown', function (event) {
    if (event.key === 'Escape') {
      hideSwatchRequestForm();
      $('#klaviyo-bis-iframe').hide();
      $('.site-header').trigger('click');
    }
  });

  $(".swatch__link-handle").click(function () {
    showSwatchRequestForm();
  });

  $("#js-swatch-anchor .btn-close").click(function () {
    hideSwatchRequestForm();
  });

  $(".modal-overlay").click(function () {
    hideSwatchRequestForm();
  });

  function showSwatchRequestForm() {
    $("#js-swatch-anchor").show();
    $(".modal-overlay").addClass("is-show");
    $("body").addClass("overflow-hidden");

    $('.pdp-product-form').find('a, button, input, label').attr('tabindex', '2');
    $('.pdp-buybox__content').find('a, button, input').attr('tabindex', '2');
  }

  function hideSwatchRequestForm() {
    $("#js-swatch-anchor").hide();
    $(".modal-overlay").removeClass("is-show");
    $("body").removeClass("overflow-hidden");
    $(".swatch__link-handle").focus();

    $('.pdp-product-form').find('a, button, input, label').removeAttr('tabindex');
    $('.pdp-buybox__content').find('a, button, input').removeAttr('tabindex');
  }

  // Account page
  // This prevents the accordion from firing when clicking links inside account sidebar menu.
  $('.account-sidebar').on('click', 'li', function(){
    $('.account-sidebar').find('.account-nav').removeClass('opened');
  });

  // Global Search
  // Remove auto search overlay when clicking on it
  $('.ss__autocomplete--target').on('click', function(){
    $('.site-header').trigger('click');
  });
 
  // Sku
  $('#reference-sku').click(function() {
    $('#reference-sku').toggleClass('show-full-sku');
  })

});